<template>
  <div>
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :count="count"
      :current="page">
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>供应商名称:</label>
            <SupplierListSelect v-model.trim="query.supplierId"></SupplierListSelect>
          </div>
          <div class="queryItem">
            <label>成本变更单号:</label>
            <lk-input
              :maxlength="100"
              placeholder="请输入"
              class="item"
              clearable
              v-model.trim="query.costChangeCode">
            </lk-input>
          </div>
          <div class="queryItem">
            <label>关联单号:</label>
            <lk-input
              :maxlength="100"
              placeholder="请输入"
              class="item"
              clearable
              v-model.trim="query.payableCode">
            </lk-input>
          </div>
          <div class="queryItem">
            <label>发票号:</label>
            <lk-input
              :maxlength="100"
              placeholder="请输入"
              class="item"
              clearable
              v-model.trim="query.invoiceCode">
            </lk-input>
          </div>
          <div class="queryItem">
            <label>商品名称:</label>
            <lk-input
              :maxlength="100"
              placeholder="通用名、商品名称、助记码"
              class="item"
              clearable
              v-model.trim="query.nameMix">
            </lk-input>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import finance from '../../services/finance';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import SupplierListSelect from '../../components/SupplierListSelect.vue';

export default {
  name: 'costChangeBill',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    SupplierListSelect,
  },
  computed: {},
  data() {
    return {
      query: {
        supplierId: null, // 供应商id
        costChangeCode: null, // 变更单号
        payableCode: null, // 应付单好
        invoiceCode: null, // 发票编号
        nameMix: null, // 商品名称
        storeIdList: [], // 门店名称
      },
      columns: [
        { title: '成本变更单号', key: 'code', minWidth: 116 },
        { title: '供应商名称', key: 'supplierName', minWidth: 116 },
        { title: '关联单号', key: 'payableCode', minWidth: 116 },
        { title: '关联单类型', key: 'typeName', minWidth: 116 },
        { title: '发票号', key: 'invoiceCode', minWidth: 116 },
        { title: '状态', key: 'statusName', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('costChangeBillInfo') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'costChangeBillInfo', params: { id: params.row.id } });
                },
              },
            }, '查看') : null,
          ]),
        },
      ],
      tableData: [],
      costChangeType: ['应付单', '供应商退货单'],
    };
  },

  methods: {
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      finance.getCostChangeList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.typeName = result.type
              ? this.costChangeType[result.type - 1]
              : '';
            result.createTime = result.createTime ? utils.formatDate(result.createTime) : '';
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {};
    },
  },
  created() {
    this.handleSearch(true);
    if (this.roleType !== 2) {
      this.columns.splice(0, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
};
</script>
<style lang="less" scoped>
</style>
